import React from "react";
//import PropTypes from 'prop-types';
import LanguageSettings from "./LanguageSettings";
import { useSelector } from "react-redux";
import { selectCurrentLanguages } from "playground/cms/state/selectors/lang";
import { useField } from "state/hooks";

function selectVisibleLanguages(languages, settings) {
    if (!settings?.mode) return languages;
    if (settings.mode === 1) {
        return languages.filter((lang) => settings.include.includes(lang.id));
    }
    if (settings.mode === 2) {
        return languages.filter((lang) => !settings.exclude.includes(lang.id));
    }
    return [];
}

export function LanguageSettingsContainer(props) {
    const {} = props;
    const projectLanguages = useSelector(selectCurrentLanguages);
    const { value, onChange } = useField(props.type, props.id, "translations");
    const visibleLanguages = selectVisibleLanguages(projectLanguages, value);
    return (
        <LanguageSettings
            languages={projectLanguages}
            visibleLanguages={visibleLanguages}
            value={value}
            onChange={onChange}
            {...props}
        />
    );
}

LanguageSettingsContainer.propTypes = {};

LanguageSettingsContainer.defaultProps = {};

export default LanguageSettingsContainer;
